<template>
  <div>
    <v-row dense class="mb-3">
      <v-col cols="12" md="4">
        <v-text-field
          v-model="filters.search"
          :label="$t('buscar')"
          clearable
          dense
          outlined
          prepend-inner-icon="mdi-magnify"
        />
      </v-col>

      <v-col cols="12" md="4">
        <v-select
          v-model="filters.status"
          :items="statusOptions"
          :label="$t('estado')"
          clearable
          dense
          outlined
        />
      </v-col>

      <v-col cols="12" md="4">
        <v-select
          v-model="filters.paymentStatus"
          :items="paymentStatusOptions"
          :label="$t('fecha_pago')"
          clearable
          dense
          outlined
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="filteredCuentas"
      :items-per-page="10"
      :footer-props="footerProps"
      :loading="loadingCuentas"
      :no-data-text="$t('sin_resultados')"
      item-key="id"
    >
      <template v-slot:item.folio="{ item }">
        {{ getFolio(item) }}
      </template>

      <template v-slot:item.fecha="{ item }">
        {{ formatDateTime(item.created_at) }}
      </template>

      <template v-slot:item.fecha_vencimiento="{ item }">
        {{ item.fecha_vencimiento || $t("nd") }}
      </template>

      <template v-slot:item.fecha_pago="{ item }">
        {{ getPaymentDate(item) }}
      </template>

      <template v-slot:item.total="{ item }">
        ${{ formatNumber(getMonto(item)) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "PagoPendiente",
  data: () => ({
    cuentas: [],
    loadingCuentas: false,
    filters: {
      search: "",
      status: "",
      paymentStatus: "",
    },
  }),
  computed: {
    headers() {
      return [
        { text: "Folio", value: "folio" },
        { text: this.$t("fecha"), value: "fecha" },
        { text: this.$t("estado"), value: "estado" },
        { text: this.$t("fecha_limite"), value: "fecha_vencimiento" },
        { text: this.$t("fecha_pago"), value: "fecha_pago" },
        { text: "Total", value: "total" },
      ];
    },
    footerProps() {
      return {
        "items-per-page-options": [10, 25, 50, -1],
        "items-per-page-text": this.$t("registros_por_pagina"),
      };
    },
    statusOptions() {
      const statuses = this.cuentas
        .map((cuenta) => cuenta.estado)
        .filter(Boolean);

      return [...new Set(statuses)].sort();
    },
    paymentStatusOptions() {
      return [
        { text: this.$t("con_fecha_pago"), value: "paid" },
        { text: this.$t("sin_fecha_pago"), value: "pending" },
      ];
    },
    filteredCuentas() {
      return this.cuentas.filter((cuenta) => {
        const search = (this.filters.search || "").toLowerCase().trim();
        const searchableText = [
          this.getFolio(cuenta),
          cuenta.estado,
          cuenta.fecha_vencimiento,
          this.getPaymentDate(cuenta),
          this.formatDateTime(cuenta.created_at),
          this.formatNumber(this.getMonto(cuenta)),
        ]
          .join(" ")
          .toLowerCase();

        const matchesSearch = !search || searchableText.includes(search);
        const matchesStatus =
          !this.filters.status || cuenta.estado === this.filters.status;
        const matchesPaymentStatus =
          !this.filters.paymentStatus ||
          (this.filters.paymentStatus === "paid" && this.hasPaymentDate(cuenta)) ||
          (this.filters.paymentStatus === "pending" &&
            !this.hasPaymentDate(cuenta));

        return matchesSearch && matchesStatus && matchesPaymentStatus;
      });
    },
  },
  methods: {
    getCuentas() {
      this.loadingCuentas = true;
      this.openLoader();
      const cxpURL = `${this.$store.state.proveedorUrl}administracion/cuentas-por-pagar`;
      const cxpParams = {
        proveedor_id: this.$store.state.user.id,
      };
      const cxpRequest = this.sendRequest(cxpURL, cxpParams);
      cxpRequest
        .then(({ data }) => (this.cuentas = data))
        .finally(() => {
          this.loadingCuentas = false;
          this.closeLoader();
        });
    },
    getFolio(cuenta) {
      return String(cuenta?.orden_compra?.folio || "").replace("amp;", "");
    },
    getMonto(cuenta) {
      return cuenta[
        `monto${
          cuenta?.orden_compra?.moneda?.internacional == "Si" ? "_dolar" : ""
        }`
      ];
    },
    getPaymentDate(cuenta) {
      return cuenta.fecha_pago || this.$t("nd");
    },
    hasPaymentDate(cuenta) {
      return Boolean(cuenta.fecha_pago);
    },
  },
  created() {
    this.getCuentas();
  },
};
</script>
